"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushPullForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var yup_1 = require("@hookform/resolvers/yup");
var yup = __importStar(require("yup"));
var lodash_1 = require("lodash");
var luxon_1 = require("luxon");
var Form_1 = require("../Form");
var Indicators_1 = require("../Indicators");
var hooks_1 = require("../../hooks");
var Form_2 = require("../Form");
var schema = yup.object({
    effectedDates: yup.string().required("cannot be blank"),
    anchorDate: yup.string().required("cannot be blank"),
    pushBy: yup
        .number()
        .typeError("length must be at least 1")
        .required()
        .nullable(),
    pushTo: yup.string().required("cannot be blank"),
});
var PushPullForm = function (_a) {
    var _b, _c, _d;
    var externalSubmitHandler = _a.onSubmit, loading = _a.loading, defaultValues = _a.defaultValues, submitTitle = _a.submitTitle, onSearch = _a.onSearch, searchResults = _a.searchResults, externalAnchorDate = _a.externalAnchorDate, _e = _a.action, action = _e === void 0 ? "Push" : _e;
    var defaultDirection = action === "Push" ? "forward" : "backward";
    var _f = (0, react_1.useState)(defaultDirection), direction = _f[0], setDirection = _f[1];
    var _g = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(schema),
        mode: "onBlur",
    }), handleSubmit = _g.handleSubmit, register = _g.register, formErrors = _g.formState.errors, watch = _g.watch, setError = _g.setError, setValue = _g.setValue, reset = _g.reset;
    (0, hooks_1.useDefaultValueListener)(defaultValues, reset);
    var _h = watch([
        "anchorDate",
        "pushTo",
        "pushBy",
        "itemsToMove",
    ]), anchorDate = _h[0], pushTo = _h[1], pushBy = _h[2], itemsToMove = _h[3];
    var _j = (0, react_1.useState)(externalAnchorDate), externalTrackedAnchor = _j[0], setExternalAnchor = _j[1];
    (0, react_1.useEffect)(function () {
        if (externalAnchorDate && externalTrackedAnchor !== externalAnchorDate) {
            setValue("anchorDate", externalAnchorDate);
            setExternalAnchor(externalAnchorDate);
        }
    }, [externalAnchorDate, externalTrackedAnchor, setExternalAnchor, setValue]);
    var handleFormSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, keys;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, externalSubmitHandler(__assign({}, data))];
                case 1:
                    _a = ((_b = (_c.sent())) !== null && _b !== void 0 ? _b : {}).errors, errors = _a === void 0 ? {} : _a;
                    keys = Object.keys(errors);
                    if (keys.length) {
                        keys.map(function (key) {
                            return setError((0, lodash_1.camelCase)(key), {
                                message: errors[key],
                            });
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); });
    var handleAnchorDateChange = (0, react_1.useCallback)(function (dates, direction) {
        var _a, _b;
        setValue("anchorDate", dates[0].toISODate());
        setValue("pushTo", (_b = (_a = dates[1]) === null || _a === void 0 ? void 0 : _a.toISODate()) !== null && _b !== void 0 ? _b : dates[0].plus({ days: pushBy }).toISODate());
        if (dates[1]) {
            setTimeout(function () {
                var _a;
                setValue("pushBy", (_a = dates[1]) === null || _a === void 0 ? void 0 : _a.startOf("day").diff(dates[0].startOf("day"), "day").days, { shouldValidate: true, shouldDirty: true });
            }, 0);
        }
        setDirection(direction !== null && direction !== void 0 ? direction : defaultDirection);
    }, [setValue, pushBy, defaultDirection]);
    var handlePushByChange = (0, react_1.useCallback)(function (e) {
        var value = parseInt(e.target.value, 10);
        if (!isNaN(value)) {
            setValue("pushBy", value);
            setValue("pushTo", luxon_1.DateTime.fromISO(anchorDate, { zone: "utc" })
                .plus({ days: value })
                .toISODate());
            setDirection(value > 0 ? "forward" : "backward");
        }
    }, [anchorDate, setValue, pushBy, pushTo]);
    var handleFilterSelect = function (newVal) {
        console.log("itemsToMove", newVal.trim());
        setValue("itemsToMove", newVal.trim());
    };
    var filterCount = (itemsToMove === null || itemsToMove === void 0 ? void 0 : itemsToMove.length) > 0 ? (_b = itemsToMove === null || itemsToMove === void 0 ? void 0 : itemsToMove.split(" ").length) !== null && _b !== void 0 ? _b : 0 : 0;
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleFormSubmit, className: "relative" }, { children: [(0, jsx_runtime_1.jsxs)(Form_1.Fields, __assign({ register: register, errors: formErrors, grow: true, className: "pb-2" }, { children: [(0, jsx_runtime_1.jsx)(Form_1.DateField, { name: "effectedDates", label: "Effected Dates", dates: [
                            luxon_1.DateTime.fromISO(anchorDate, { zone: "utc" }),
                            luxon_1.DateTime.fromISO(pushTo, { zone: "utc" }),
                        ], onDateChange: handleAnchorDateChange, error: (_c = formErrors.anchorDate) === null || _c === void 0 ? void 0 : _c.message, required: true, className: "w-full", range: true }, void 0), (0, jsx_runtime_1.jsxs)(Form_1.Fields, __assign({ nested: true, grow: true }, { children: [(0, jsx_runtime_1.jsx)(Form_1.DateField, { name: "updateAnchorDate", label: "Push/Pull From", dates: [luxon_1.DateTime.fromISO(anchorDate, { zone: "utc" })], onDateChange: handleAnchorDateChange, error: (_d = formErrors.anchorDate) === null || _d === void 0 ? void 0 : _d.message, required: true, className: "w-full" }, void 0), (0, jsx_runtime_1.jsx)(Form_2.TextField, { name: "pushBy", label: "Days", className: "w-full", type: "number", onChange: handlePushByChange, value: "" + pushBy, selfControllable: true }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(Form_1.MultiSelect, { id: "items", name: "itemsToMove", onChange: onSearch, value: itemsToMove, onSelect: handleFilterSelect, options: searchResults, label: "What do you want to move?", placeholder: "leave blank to " + action.toLowerCase() + " entire calendar", selfControllable: true, isMulti: true }, void 0), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "itemsToMove" }, void 0), (0, jsx_runtime_1.jsxs)("p", __assign({ className: "bg-gray-100 text-sm rounded p-2" }, { children: [(itemsToMove === null || itemsToMove === void 0 ? void 0 : itemsToMove.length) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Events that match the", " ", (0, jsx_runtime_1.jsxs)("strong", __assign({ className: "font-bold" }, { children: [filterCount, " ", filterCount > 1 ? "filters" : "filter"] }), void 0), " ", "which occur", " "] }, void 0)) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("strong", __assign({ className: "font-bold" }, { children: "Any event" }), void 0), " on the entire calendar occuring"] }, void 0)), " ", "on or", " ", (0, jsx_runtime_1.jsxs)("strong", __assign({ className: "font-bold" }, { children: [direction === "forward" ? "after" : "before", " ", luxon_1.DateTime.fromISO(anchorDate, { zone: "utc" }).toFormat("MMMM, d")] }), void 0), " ", "will be", " ", (0, jsx_runtime_1.jsx)("strong", __assign({ className: "font-bold" }, { children: direction === "forward" ? "pushed forward" : "pulled backward" }), void 0), " ", "by", " ", (0, jsx_runtime_1.jsxs)("strong", __assign({ className: "font-bold" }, { children: [direction === "forward" ? pushBy : -pushBy, " ", Math.abs(pushBy) > 1 ? "days" : "day"] }), void 0), "."] }), void 0), (0, jsx_runtime_1.jsx)(Form_1.ErrorList, { errors: formErrors }, void 0), (0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ type: "submit", className: "mt-2 w-full" }, { children: submitTitle !== null && submitTitle !== void 0 ? submitTitle : (direction === "forward" ? "Push" : "Pull") + " " + (filterCount > 0 ? "Matching Events" : "Entire Calendar") + " " + (direction === "forward" ? pushBy : -pushBy) + " " + (Math.abs(pushBy) > 1 ? "Days" : "Day") }), void 0), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "anchorDate", value: anchorDate }, void 0), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "pushTo", value: pushTo }, void 0), (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "pushBy", value: pushBy }, void 0)] }), void 0), loading ? (0, jsx_runtime_1.jsx)(Indicators_1.AbsoluteOverlay, {}, void 0) : null] }), void 0));
};
exports.PushPullForm = PushPullForm;
